import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

interface HoverPremiumCardProps {
  title: string;
  description: string;
  icon?: LucideIcon;
  image?: string;
  className?: string;
}

const HoverPremiumCard = ({
  title,
  description,
  icon: Icon,
  image,
  className,
}: HoverPremiumCardProps) => {
  return (
    <div
      className={cn(
        "group bg-card border border-border overflow-hidden",
        "transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]",
        "hover:-translate-y-1.5 hover:shadow-[0_16px_48px_-12px_rgba(0,0,0,0.15)]",
        "hover:border-accent/40",
        "focus-within:-translate-y-1.5 focus-within:shadow-[0_16px_48px_-12px_rgba(0,0,0,0.15)]",
        className
      )}
    >
      {image && (
        <div className="aspect-[16/10] overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.03]"
            loading="lazy"
          />
        </div>
      )}
      <div className="p-6 md:p-8">
        {Icon && (
          <Icon
            className="w-6 h-6 text-accent mb-4 transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:translate-x-0.5"
            strokeWidth={1.5}
          />
        )}
        <h3 className="font-headline text-lg md:text-xl text-foreground mb-2">
          {title}
        </h3>
        <p className="text-muted-foreground text-sm leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
};

export default HoverPremiumCard;
